import type { StaticLayerPayload } from "@config";
import { DividerLibrary } from "@library-elements/divider";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: DividerLibrary,
};

export const Divider = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
